<template >
  <div>
    <van-nav-bar
        title="天津高考词汇手册3500搜索"
        left-text=""
        left-arrow
        @click-left="goBackHomepage()"
        @click-right="logout()"
    >
    </van-nav-bar>

    <van-form @submit="onSubmit">
      
      <div class="primary-search-wrapper">
        <van-field
            class="primary-search-field"
            required
            left-icon="search"
            v-model="beginWordsShow"
            name="开头"
            center
            clearable
            size="large"
            placeholder="请输入要查询的单词开头..."
            autocomplete="off"
            @input="openBeginSuggestions"
            @focus="openBeginSuggestions"
            @blur="closeBeginSuggestions"
            @keydown.native.down.prevent="moveBeginSuggestion(1)"
            @keydown.native.up.prevent="moveBeginSuggestion(-1)"
            @keydown.native.esc.prevent="hideBeginSuggestions"
            @keydown.native.enter.prevent="handleBeginSuggestionEnter"
        >
          <template #label>
            <span class="primary-label">单词开头</span>
          </template>
          <template #button>
            <van-button size="small" type="primary" round @click="popBeginMuti()">添加多项</van-button>
          </template>
        </van-field>
        <div
            v-if="showBeginSuggestions"
            class="begin-suggestion-panel"
        >
          <div class="begin-suggestion-header">
            <span>联想词 · 点击填入</span>
            <span>{{ beginWordSuggestions.length }} 个</span>
          </div>
          <div class="begin-suggestion-list" role="listbox">
            <button
                v-for="(item, index) in beginWordSuggestions"
                :key="item.word"
                type="button"
                class="begin-suggestion-item"
                :class="{ active: index === activeBeginSuggestionIndex }"
                role="option"
                :aria-selected="index === activeBeginSuggestionIndex"
                @mousedown.prevent="selectBeginSuggestion(item.word)"
                @click="selectBeginSuggestion(item.word)"
                @mouseenter="activeBeginSuggestionIndex = index"
            >
              <span class="begin-suggestion-word">
                <strong>{{ beginSuggestionPrefix(item.word) }}</strong>{{ beginSuggestionSuffix(item.word) }}
              </span>
              <span class="begin-suggestion-meta">
                <span v-if="item.attribute" class="begin-suggestion-attribute">{{ item.attribute }}</span>
                <span class="begin-suggestion-meaning">{{ item.meaning }}</span>
              </span>
            </button>
          </div>
        </div>
      </div>

      <van-popup v-model="showBeginMuti" position="bottom" :style="{ height: '50%' }">
        <van-row >
          <van-col span="4">
            <van-button type="primary" plain size="large" @click="mutiBeginOnConfirm">确定</van-button>
          </van-col>
          <van-col span="8" offset="8">
          </van-col>
          <van-col span="4">
            <van-button type="primary"  plain size="large" @click="clearmutiBegin">清空</van-button>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-between" style="margin-top: 2%">
          <van-col span="22" offset="1">
            <vue-tags-input
                v-model="tagBegin"
                :tags="tagsBegin"
                @tags-changed="newTags => tagsBegin = newTags"

            />
          </van-col>

        </van-row>
      </van-popup>
      <van-row>
        <van-field
            readonly
            clickable
            :value="attributeValue"
            name="picker"
            label="词性"
            left-icon="wechat"
            placeholder="点击选择词性"
            @click="showPickerAttribute = true"
        />
      </van-row>
      <van-popup v-model="showPickerAttribute" position="bottom" :style="{ height: '70%' }">
        <van-row type="flex" justify="space-between">
          <van-col span="4">
            <van-button type="default"  size="normal" @click="attributeOnConfirm">确定</van-button>
          </van-col>
          <van-col span="4">
            <van-button type="default"  size="normal" @click="clearAttributeSelected">清空</van-button>
          </van-col>
        </van-row>
        <van-row>
          <van-search
              v-model="valueAttribute"
              placeholder="输入词性（支持中英）"
              show-action
              input-align="center"
              @search="onSearchAttribute"
              @cancel="onCancelAttribute"
          />
        </van-row>
        <van-checkbox-group v-model="attributeSelected">
          <van-cell-group>
            <van-cell
                v-for="(attribute, index) in attributeColumns"
                clickable
                :key="attribute.英文"
                :title="`${attribute.中文 + ' ' + attribute.英文}`"
                @click="toggleAttribute(index)"
            >
              <template #right-icon>
                <van-checkbox :name="attribute" ref="checkboxes"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <van-popup v-model="showPickerMiniAttribute" position="bottom" :style="{ height: '70%' }">
          <div style="font-size: 16px; font-weight:bold;margin: 4%">选择词性</div>
          <van-checkbox-group  style="margin: 2%" v-model="attributeMiniSelected">
            <van-cell-group>
              <van-cell
                  v-for="(attribute, index) in attributeMiniColumns"
                  clickable
                  :key="attribute.英文"
                  :title="`${attribute.中文 + ' ' + attribute.英文}`"
                  @click="toggleMiniAttribute(index)"
              >
                <template #right-icon>
                  <van-checkbox :name="attribute" ref="checkboxesMini"/>
                </template>
              </van-cell>
            </van-cell-group>
            <van-button style="margin-top: 2%" type="primary" block @click="attributeMiniOnConfirm">确认</van-button>
          </van-checkbox-group>
        </van-popup>
      </van-popup>
      
      <van-field
          left-icon="lock"
          v-model="endWordsShow"
          name="结尾"
          label="结尾"
          placeholder="搜索结尾字母"
      >
        <template #button>
          <van-button size="small" type="warning" @click="popEndMuti()">添加多项</van-button>
        </template>
      </van-field>
      <van-popup v-model="showEndMuti" position="bottom" :style="{ height: '50%' }">
        <van-row >
          <van-col span="4">
            <van-button type="warning" plain size="large" @click="mutiEndOnConfirm">确定</van-button>
          </van-col>
          <van-col span="8" offset="8">
          </van-col>
          <van-col span="4">
            <van-button type="warning"  plain size="large" @click="clearmutiEnd">清空</van-button>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-between" style="margin-top: 2%">
          <van-col span="22" offset="1">
            <vue-tags-input
                v-model="tagEnd"
                :tags="tagsEnd"
                @tags-changed="newTags => tagsEnd = newTags"
            />
          </van-col>

        </van-row>

      </van-popup>
      <van-field
          left-icon="column"
          v-model="containWordsShow"
          name="包含"
          label="包含"
          placeholder="搜索包含字母"
      >
        <template #button>
          <van-button size="small" type="danger" @click="popContainMuti()">添加多项</van-button>
        </template>
      </van-field>
      <van-popup v-model="showContainMuti" position="bottom" :style="{ height: '50%' }">
        <van-row >
          <van-col span="4">
            <van-button type="danger" plain size="large" @click="mutiContainOnConfirm">确定</van-button>
          </van-col>
          <van-col span="8" offset="8">
          </van-col>
          <van-col span="4">
            <van-button type="danger"  plain size="large" @click="clearmutiContain">清空</van-button>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-between" style="margin-top: 2%">
          <van-col span="22" offset="1">
            <vue-tags-input
                v-model="tagContain"
                :tags="tagsContain"
                @tags-changed="newTags => tagsContain = newTags"
            />
          </van-col>

        </van-row>

      </van-popup>
      <van-row>
        <van-field
            readonly
            clickable
            value=""
            name="picker"
            label="辨析"
            left-icon="edit"
            placeholder="3500词汇辨析"
            @click="getSynonym()"
        />
      </van-row>
      <van-cell center title="同时搜索教材" style="font-size: 13px">
        <template #right-icon>
          <van-switch v-model="checkedBooks" size="24" />
        </template>
      </van-cell>
    </van-form>

    <van-button native-type="button" style="margin-top: 5%; margin-left: 0.2%" type="primary" block round plain @click="filterData()">筛选</van-button>
    <van-button style="margin-top: 2%; margin-left: 0.2%" type="danger" block round plain @click="filterClear()">清空</van-button>

    <van-tag v-if="$store.state.tagShow3500" type="primary" style="margin-left: 70%; margin-top: 4%" size="medium" plain round @click="queryUpdate()">点击更新单词?</van-tag>
      <van-loading
        v-show="$store.state.loadingWords3500"
        style="margin-left: 67%; margin-top: 4%"
        type="spinner"
        text-size="12px"
        color="#1989fa">3500加载中...
    </van-loading>
  </div>
</template>

<script>
import { Toast } from 'vant'
import axios from "axios";
import { matchesAttribute } from "../utils/gaokao";
import { Dialog } from 'vant';
import VueTagsInput from '@johmun/vue-tags-input';
import $ from "jquery";
// http://www.vue-tags-input.com/#/

export default {
  name: "filter3500",
  components: {
    [Dialog.Component.name]: Dialog.Component,
    VueTagsInput,
  },
  data(){
    return {
      // 词性
      attributeValue: '',
      attributeSelected: [],
      showPickerAttribute: false,
      attributeColumns: [ {'英文':'v', '中文': '动词'},
        {'英文':'n', '中文': '名词'}, {'英文':'pron', '中文': '代词'}, {'英文':'adj', '中文': '形容词'}, {'英文':'adv', '中文': '副词'}, {'英文':'prep', '中文': '介词'},
        {'英文':'conj', '中文': '连词'}, {'英文':'num', '中文': '数词'}, {'英文':'exclaim', '中文': '感叹词'},
        {'英文':'article', '中文': '冠词'}],
      // 搜索词性
      valueAttribute: '',
      showPopoverAttribute: false,

      attributeMiniColumns: [],
      attributeMiniSelected: [],
      showPickerMiniAttribute: false,
      // 开头
      beginWordsShow:"",
      beginSuggestionsOpen: false,
      activeBeginSuggestionIndex: -1,
      beginWords2: [],
      newBeginTag: '',
      disabled: false,
      showBeginMuti: false,
      tagBegin: '',
      tagsBegin: [],
      //结尾
      endWordsShow: '',
      endWords: "",
      endWords2: [],
      showEndMuti: false,
      tagEnd: '',
      tagsEnd: [],
      //包含
      containWords: "",
      containWordsShow: "",
      containWords2: [],
      showContainMuti: false,
      tagContain: '',
      tagsContain: [],
      // 是否搜索教材单词
      checkedBooks: true,
    }
  },
  methods:{
    openBeginSuggestions(){
      this.beginSuggestionsOpen = this.currentBeginKeyword.length > 0;
      this.activeBeginSuggestionIndex = -1;
    },
    closeBeginSuggestions(){
      window.setTimeout(() => this.hideBeginSuggestions(), 180);
    },
    hideBeginSuggestions(){
      this.beginSuggestionsOpen = false;
      this.activeBeginSuggestionIndex = -1;
    },
    moveBeginSuggestion(step){
      if(!this.showBeginSuggestions){
        this.openBeginSuggestions();
      }
      const count = this.beginWordSuggestions.length;
      if(!count)return;
      if(this.activeBeginSuggestionIndex < 0){
        this.activeBeginSuggestionIndex = step > 0 ? 0 : count - 1;
        return;
      }
      this.activeBeginSuggestionIndex =
          (this.activeBeginSuggestionIndex + step + count) % count;
    },
    selectBeginSuggestion(word){
      const values = (this.beginWordsShow || '').split(',');
      values[values.length - 1] = word;
      this.beginWordsShow = values.join(',');
      this.hideBeginSuggestions();
    },
    handleBeginSuggestionEnter(){
      if(this.showBeginSuggestions && this.activeBeginSuggestionIndex >= 0){
        this.selectBeginSuggestion(
            this.beginWordSuggestions[this.activeBeginSuggestionIndex].word
        );
        return;
      }
      this.hideBeginSuggestions();
      this.filterData();
    },
    beginSuggestionPrefix(word){
      return word.slice(0, this.currentBeginKeyword.length);
    },
    beginSuggestionSuffix(word){
      return word.slice(this.currentBeginKeyword.length);
    },
    onSubmit(){

    },
    onClickLeft(){

    },
    goBackHomepage(){
      // this.$router.go(-1)
      this.$router.push({ name: 'homepage', params: {}});
    },
    // 搜索同义词
    getSynonym(){
      this.attributeValue = "";
      this.attributeSelected = [];
      this.beginWordsShow = "";
      this.endWordsShow = "";
      this.containWords = "";
      this.$store.state.synonymResult = [];
      let regSynonym = /【辨析.*/;
      let regSynonymTitle = /【辨析】(.*?[a-zA-Z]+)[^\x00-\xff]/;
      for(let i=0;i<this.$store.state.gaokaoWords.length;i++){
        if(this.$store.state.gaokaoWords[i]['中文'].match(regSynonym) != null){
          let obj = {};
          let content = this.$store.state.gaokaoWords[i]['中文'].match(regSynonym)[0];
          obj['synonymContent'] = content;
          obj['synonymTitle'] = content.match(regSynonymTitle)[1];
          obj['word'] = this.$store.state.gaokaoWords[i]['英文'];
          obj['attribute'] = this.$store.state.gaokaoWords[i]['词性'];
          obj['translation'] = this.$store.state.gaokaoWords[i]['中文'];
          this.$store.state.synonymResult.push(obj);
        }
      }
      // console.log('arraySynonym', this.$store.state.synonymResult);
      this.$router.push({ name: 'synonymList', params: {}});
    },
    // 搜索词性
    attributeMiniOnConfirm(){
      // 二级搜索词性确认按钮
      this.showPickerMiniAttribute = false;
      this.attributeSelected = this.attributeMiniSelected;
      this.valueAttribute = '';
    },
    onCancelAttribute(){
      // 词性搜索取消按钮
      this.valueAttribute = ''
    },
    onSearchAttribute(){
      // 词性搜索确认回车
      let attributeColumnsNew = [];
      if(this.valueAttribute != ""){
        for(let i=0;i<this.attributeColumns.length;i++){
          if(this.attributeColumns[i]['中文'].indexOf(this.valueAttribute) != -1 ||
              this.attributeColumns[i]['英文'].indexOf(this.valueAttribute) != -1){
            attributeColumnsNew.push(this.attributeColumns[i])
          }
        }
        this.attributeMiniColumns = attributeColumnsNew
      }
      this.showPickerMiniAttribute = true
      // console.log('attributeColumnsNew', attributeColumnsNew)
    },
    toggleMiniAttribute(index){
      this.$refs.checkboxesMini[index].toggle();
    },
    // 词性
    attributeOnConfirm(){
      // console.log(this.attributeSelected)
      let listAtrributeValue = [];
      for(let i=0;i<this.attributeSelected.length;i++){
        listAtrributeValue.push(this.attributeSelected[i]['中文'])
      }
      // this.getAttributeValue(this.attributeSelected)
      this.getAttributeValue(listAtrributeValue)
      this.showPickerAttribute = false
    },
    clearAttributeSelected(){
      this.attributeSelected = []
      this.attributeValue = ""
    },
    toggleAttribute(index){
      this.$refs.checkboxes[index].toggle();
    },
    getAttributeValue(attributeList){
      if(attributeList.length > 0){
        let attributeNumber = attributeList.length
        if(attributeNumber == 1){
          this.attributeValue = attributeList[0]
        }
        if(attributeNumber == 2){
          this.attributeValue = attributeList[0] + "," + attributeList[1]
        }
        if(attributeNumber > 2){
          this.attributeValue = attributeList[0] + ','
              + attributeList[1] + '等'
              + attributeNumber + '个'
        }
      }
    },
    // 按钮
    filterData(){
      // 筛选数据
      // this.judgeLogout();   判断是否需要重新登陆
      this.beginWordsShow = this.commonApi.trimStr(this.beginWordsShow.toLowerCase());
      this.endWordsShow = this.commonApi.trimStr(this.endWordsShow.toLowerCase());
      this.containWordsShow = this.commonApi.trimStr(this.containWordsShow.toLowerCase());
      // console.log(this.beginWordsShow, this.endWordsShow, this.containWordsShow);
      if(this.beginWordsShow.length == 0 && this.endWordsShow.length == 0 && this.containWordsShow.length == 0){
        Toast.fail('输入查询内容');
        return;
      }
      // console.log(this.beginWordsShow)
      // 筛选3500
      function filter3500(beginWordsShow, endWords, containWords, attributeSelected, gaokaoWords){
        // 起始单词
        function filterBegin(beginWordsShow, gaokaoWords){
          // push 3500单词
          let fitlerResult_1 = [];
          if(beginWordsShow.length != 0 ){
            for(let i = 0; i < gaokaoWords.length; i++){
              for(let j = 0;j < beginWordsShow.split(',').length; j++){
                if(gaokaoWords[i]['英文'].indexOf(beginWordsShow.split(',')[j]) == 0){
                  let obj = {};
                  obj['中文'] = gaokaoWords[i]['中文']
                  obj['英文'] = gaokaoWords[i]['英文']
                  obj['词性'] = gaokaoWords[i]['词性']


                  fitlerResult_1.push(obj)
                }
              }
            }
          }else{
            fitlerResult_1 = gaokaoWords
          }
          return fitlerResult_1
        }

        let fitlerResult1 = filterBegin(beginWordsShow, gaokaoWords);

        // 末尾单词
        function filterEnd(endWords, fitlerResult1) {
          let fitlerResult_1 = [];
          // push 3500
          if (endWords.length != 0) {
            for (let i = 0; i < fitlerResult1.length; i++) {
                for(let j = 0; j < endWords.split(',').length; j++){
                  let start = fitlerResult1[i]['英文'].length - endWords.split(',')[j].length;
                  let arr = fitlerResult1[i]['英文'].substr(start, endWords.split(',')[j].length);
                  if (arr == endWords.split(',')[j]) {
                    let obj = {};
                    obj['中文'] = fitlerResult1[i]['中文']
                    obj['英文'] = fitlerResult1[i]['英文']
                    obj['词性'] = fitlerResult1[i]['词性']


                    fitlerResult_1.push(obj)
                  }
                }
            }
          } else {
            fitlerResult_1 = fitlerResult1
          }
          return fitlerResult_1
        }

        let fitlerResult2 = filterEnd(endWords, fitlerResult1);

        // 包含单词
        function filterContain(containWords, fitlerResult2){
          let fitlerResult3 = [];
          if(containWords.length != 0 ){
            for(let i = 0; i < fitlerResult2.length; i++){
              for(let j = 0; j < containWords.split(',').length; j++){
                if(fitlerResult2[i]['英文'].indexOf(containWords.split(',')[j]) != -1){
                  let obj = {};
                  obj['中文'] = fitlerResult2[i]['中文']
                  obj['英文'] = fitlerResult2[i]['英文']
                  obj['词性'] = fitlerResult2[i]['词性']


                  fitlerResult3.push(obj)
                }
              }
            }
          }else{
            fitlerResult3 = fitlerResult2
          }
          return fitlerResult3
        }
        let fitlerResult3 = filterContain(containWords, fitlerResult2)

        // console.log('fitlerResult3_包含', fitlerResult3)

        // 词性
        function filterAttribute(attributeSelected, words) {
          return words.filter(word => !attributeSelected.length ||
            attributeSelected.some(selected => matchesAttribute(selected.英文, word.词性)));
        }
        let fitlerResult4 = filterAttribute(attributeSelected, fitlerResult3);
        return fitlerResult4
      };
      function filterBooks(beginWordsShow, endWords, containWords, attributeSelected, booksWords){
        // 起始单词
        // console.log('booksWords', booksWords)
        function filterBegin(beginWordsShow, booksWords){
          // push 3500单词
          let fitlerResult_1 = [];
          if(beginWordsShow.length != 0 ){
            for(let i = 0; i < booksWords.length; i++){
              for(let j = 0; j < beginWordsShow.split(',').length; j++){
                if(booksWords[i]['英文'] == false || booksWords[i]['英文'] == true){
                  booksWords[i]['英文'] = booksWords[i]['英文'].toString()
                }
                if(booksWords[i]['英文'].indexOf(beginWordsShow.split(',')[j]) == 0){
                  let obj = {};
                  obj['中文'] = booksWords[i]['中文']
                  obj['英文'] = booksWords[i]['英文']
                  obj['词性'] = booksWords[i]['词性']
                  obj['模块'] = booksWords[i]['模块']
                  fitlerResult_1.push(obj)
                }
              }
            }
          }else{
            fitlerResult_1 = booksWords
          }
          return fitlerResult_1
        }
        let fitlerResult1 = filterBegin(beginWordsShow, booksWords);
        // console.log('fitlerResult1_开始', fitlerResult1)

        // 末尾单词
        function filterEnd(endWords, fitlerResult1) {
          let fitlerResult_1 = [];
          // push 3500
          if (endWords.length != 0) {
            for (let i = 0; i < fitlerResult1.length; i++) {
              for(let j = 0; j < endWords.split(',').length; j++){
                let start = fitlerResult1[i]['英文'].length - endWords.split(',')[j].length;
                let arr = fitlerResult1[i]['英文'].substr(start, endWords.split(',')[j].length);
                if (arr == endWords.split(',')[j]) {
                  let obj = {};
                  obj['中文'] = fitlerResult1[i]['中文']
                  obj['英文'] = fitlerResult1[i]['英文']
                  obj['词性'] = fitlerResult1[i]['词性']
                  obj['模块'] = fitlerResult1[i]['模块']
                  fitlerResult_1.push(obj)
                }
              }
            }
          } else {
            fitlerResult_1 = fitlerResult1
          }
          return fitlerResult_1
        }

        let fitlerResult2 = filterEnd(endWords, fitlerResult1);
        // console.log('fitlerResult2_末尾', fitlerResult2)

        // 包含单词
        function filterContain(containWords, fitlerResult2){
          let fitlerResult3 = [];
          if(containWords.length != 0 ){
            for(let i = 0;i < fitlerResult2.length; i++){
              for(let j = 0;j < containWords.split(',').length; j++){
                if(fitlerResult2[i]['英文'].indexOf(containWords.split(',')[j]) != -1){
                  let obj = {};
                  obj['中文'] = fitlerResult2[i]['中文']
                  obj['英文'] = fitlerResult2[i]['英文']
                  obj['词性'] = fitlerResult2[i]['词性']
                  obj['模块'] = fitlerResult2[i]['模块']
                  fitlerResult3.push(obj)
                }
              }
            }
          }else{
            fitlerResult3 = fitlerResult2
          }
          return fitlerResult3
        }
        let fitlerResult3 = filterContain(containWords, fitlerResult2)
        // console.log('fitlerResult3_包含', fitlerResult3)

        // 词性
        function filterAttribute(attributeSelected, fitlerResult3){
          let fitlerResult4 = [];
          let attributeSearch = ""
          if(attributeSelected.length != 0){
            for(let i = 0;i < fitlerResult3.length; i++){
              for(let j = 0; j < attributeSelected.length; j++){
                if(fitlerResult3[i]['词性'] != "" && fitlerResult3[i]['词性'] != NaN){
                  if(fitlerResult3[i]['词性'].search('/') == -1){
                    // 只有一个词性
                    attributeSearch = fitlerResult3[i]['词性']
                    if(attributeSelected[j]['英文'] + '.' == attributeSearch
                        && fitlerResult3[i]['词性']
                    ){
                      let obj = {};
                      obj['中文'] = fitlerResult3[i]['中文']
                      obj['英文'] = fitlerResult3[i]['英文']
                      obj['词性'] = fitlerResult3[i]['词性']
                      obj['模块'] = fitlerResult3[i]['模块']
                      fitlerResult4.push(obj)
                    }
                  }else{
                    // 有多个词性
                    attributeSearch = fitlerResult3[i]['词性'].split('/')
                    for(let k = 0; k < attributeSearch.length;k++){
                      if(attributeSelected[j]['英文'] + '.' == attributeSearch[k]
                          && fitlerResult3[i]['词性'] != NaN
                      ){
                        let obj = {};
                        obj['中文'] = fitlerResult3[i]['中文']
                        obj['英文'] = fitlerResult3[i]['英文']
                        obj['词性'] = fitlerResult3[i]['词性']
                        obj['模块'] = fitlerResult3[i]['模块']
                        fitlerResult4.push(obj)
                      }
                    }
                  }
                }
              }
            }
          }else{
            fitlerResult4 = fitlerResult3
          }
          return fitlerResult4
        }
        let fitlerResult4 = filterAttribute(attributeSelected, fitlerResult3);
        // console.log('fitlerResult_cixing', fitlerResult4)
        return fitlerResult4
      };
      let fitlerResult4 = filter3500(this.beginWordsShow, this.endWordsShow, this.containWordsShow, this.attributeSelected, this.$store.state.gaokaoWords); // 3500
      // console.log("filter3500Result:", fitlerResult4);
      let fitlerResult5 = [];
      if(this.checkedBooks){
        fitlerResult5 = filterBooks(this.beginWordsShow, this.endWordsShow, this.containWordsShow, this.attributeSelected, this.$store.state.newWords); // 教材
      }
      // 合并俩个结果
      // console.log('fitlerResult5', fitlerResult5);
      // console.log('fitlerResult4', fitlerResult4);
      function mergeResult(booksWords, gaokaoWords){
        if(gaokaoWords.length == 0){
          return booksWords
        }else{
          let fitlerResult_3 = [...gaokaoWords, ...booksWords]
          let fitlerResult_4 = [];
          let obj = {};
          for(let i = 0; i < fitlerResult_3.length; i++){
            if(!obj[fitlerResult_3[i].英文]){
              fitlerResult_4.push(fitlerResult_3[i]);
              obj[fitlerResult_3[i].英文] = true;
            }
          }
          // console.log(fitlerResult_4)
          return fitlerResult_4
        }
      }
      let filterResult = mergeResult(fitlerResult5, fitlerResult4)

      // 跳转
      if(filterResult.length != 0){
        this.$store.state.filterResult = filterResult;
        this.simplifyTranslation();
        this.getBooksInfo();
        // console.log('filterResult', this.$store.state.filterResult);
        let res = new Promise( (resolve, reject) => {
          this.$router.push({ name: 'wordsList', params: {'typeShow': '3500'}});
          resolve('ok');
        })
        res.then( res => {
          Toast.success('共' + this.$store.state.filterResult.length + '条');
        })
      }else{
          Toast.fail('未查到单词');
      }
    },
    filterClear(){
      this.hideBeginSuggestions();
      this.attributeValue = "";
      this.attributeSelected = [];
      this.beginWordsShow = "";
      this.beginWords2 = [];
      this.endWordsShow = "";
      this.endWords2 = [];
      this.containWordsShow = "";
      this.containWords2 = [];

    },
    // 判断异地登陆
    async queryLogout(){
      let params = new URLSearchParams();
      const tokenStr = window.localStorage.getItem('Authorization3500');
      const userString = decodeURIComponent(escape(window.atob(tokenStr.split('.')[1])));
      const tokenData = JSON.parse(userString);
      const username = tokenData['data']['username'];
      params.append('method', 'post');
      params.append('username', username);
      return await axios.post('judgelogout/', params).then( (ret) => {
        return ret.data;
      })
    },
    judgeLogout(){
      let res = new Promise((resolve, reject) => {
        resolve(this.queryLogout());
      })
      res.then( res => {
        if(res == 'logout'){
          localStorage.removeItem('Authorization3500');
          this.$router.push({ name: 'login'});
          Toast("请重新登陆");
        }
      })

    },
    // 登出
    logout(){
      window.localStorage.removeItem('Authorization3500');
      this.$router.push({ name: 'login'});
    },
    // 开头字母
    popBeginMuti(){
      this.showBeginMuti = true;
    },
    mutiBeginOnConfirm(){
     this.showBeginMuti = false;
      for(let i=0;i<this.tagsBegin.length;i++){
       this.beginWords2.push(this.tagsBegin[i].text);
      }
      this.beginWordsShow = this.beginWords2.toString();
      this.tagsBegin = []
    },
    clearmutiBegin(){
      this.beginWords2 = [];
      this.tagsBegin = [];
    },
    // 结尾字母
    popEndMuti(){
      this.showEndMuti = true;
    },
    mutiEndOnConfirm(){
      this.showEndMuti = false;
      for(let i=0;i<this.tagsEnd.length;i++){
        this.endWords2.push(this.tagsEnd[i].text);
      }
      this.endWordsShow = this.endWords2.toString();
      this.tagsEnd = []
    },
    clearmutiEnd(){
      this.endWords2 = [];
      this.tagsEnd = [];
    },
    // 包含字母
    popContainMuti(){
      this.showContainMuti = true;
    },
    mutiContainOnConfirm(){
      this.showContainMuti = false;
      for(let i = 0; i < this.tagsContain.length; i++){
        this.containWords2.push(this.tagsContain[i].text);
      }
      this.containWordsShow = this.containWords2.toString();
      this.tagsContain = []
    },
    clearmutiContain(){
      this.containWords2 = [];
      this.tagsContain = [];
    },
    // 得到列表解释
    simplifyTranslation(){
      for(let i=0;i<this.$store.state.filterResult.length;i++){
        this.$store.state.filterResult[i]['简单中文'] = this.$store.state.filterResult[i].中文.substr(0,35);
      }
    },
    // 得到教材信息
    getBooksInfo(){
      for(let i = 0; i < this.$store.state.filterResult.length; i++){
        for(let j = 0; j < this.$store.state.newWords.length; j++){
            if(this.$store.state.filterResult[i]['英文'] == this.$store.state.newWords[j]['英文']){
              // console.log(this.$store.state.newWords[j])
              let books = this.$store.state.newWords[j]['教材'] + ' '
                  + this.$store.state.newWords[j]['模块'] + '\n'
                  + this.$store.state.newWords[j]['中文'] + '\n'
                  + '-------------------------------' + '\n'
              // if(this.$store.state.filterResult[i]['英文']=='first name') console.log(books)
              if(this.$store.state.filterResult[i]['教材'] == ""){
                this.$store.state.filterResult[i]['教材'] = books;
              }else{
                this.$store.state.filterResult[i]['教材'] = books + this.$store.state.filterResult[i]['教材'];
              }
              continue
            }
            if(this.$store.state.filterResult[i]['英文'] != this.$store.state.newWords[j]['英文'] && this.$store.state.filterResult[i]['教材'] == undefined){
              this.$store.state.filterResult[i]['教材'] = "";
            }
        }
      }
    },
    // 清楚教材信息
    booksClear(){
      for(let word of this.$store.state.gaokaoWords){
        word['教材'] = '';
      }
    },
    // 更新数据
    async queryUpdate(){
      this.$store.state.tagShow3500 = false;
      this.$store.state.loadingWords3500 = true;
      try {
        const words3500Data = await this.commonApi.getWords3500();
        this.$store.state.gaokaoWords = words3500Data.data;
        this.commonApi.writeWordCache('words3500', words3500Data);
        Toast.success('更新成功');
      } catch(error) {
        console.error('3500词库更新失败', error);
        Toast.fail('更新失败，已保留离线词库');
      } finally {
        this.$store.state.loadingWords3500 = false;
      }
    },
    // 判断是否更新数据
    ifUpdate(){
      const gaokaoVersion = this.commonApi.getCachedWords3500().version;
      async function queryifUpdate(){
        let params = new URLSearchParams();
        params.append('method', 'words3500');
        params.append('version', gaokaoVersion);
        return await axios.post('ifUpdate/', params).then( (ret) => {
          return ret.data
        })
      }
      let res = new Promise((resolve, reject) => {
        resolve(queryifUpdate())
      });
      res.then( res => {
        // console.log("是否更新?", res);
        if(res == true)this.$store.state.tagShow3500=true
      })

    },

  },
  activated() {
    this.filterClear();
    this.booksClear();
    // 更改css
    $(".van-nav-bar__right").css({'padding': '10px'})
  },
  computed: {
    currentBeginKeyword() {
      const values = (this.beginWordsShow || '').split(',');
      return values[values.length - 1].trim().toLowerCase();
    },
    beginWordSuggestions() {
      const keyword = this.currentBeginKeyword;
      const words = Array.isArray(this.$store.state.gaokaoWords)
          ? this.$store.state.gaokaoWords
          : [];
      if(!keyword)return [];

      const uniqueWords = new Map();
      words.forEach(item => {
        const word = item && item['英文'] ? item['英文'].toString().trim() : '';
        const normalizedWord = word.toLowerCase();
        if(word && normalizedWord.indexOf(keyword) === 0 && !uniqueWords.has(normalizedWord)){
          uniqueWords.set(normalizedWord, {
            word: word,
            attribute: item['词性'] || '',
            meaning: item['中文'] || ''
          });
        }
      });

      return Array.from(uniqueWords.values())
          .sort((a, b) => a.word.length - b.word.length || a.word.localeCompare(b.word))
          .slice(0, 8);
    },
    showBeginSuggestions() {
      return this.beginSuggestionsOpen && this.beginWordSuggestions.length > 0;
    },
    state() {
      return this.beginWords2.indexOf(this.newBeginTag.trim()) > -1 ? false : null
    },

  },
  created() {

  },
  mounted() {

    // console.log('gaokaoWords: ', this.$store.state.gaokaoWords);
    if(this.commonApi.readWordCache('words3500')){
      this.ifUpdate();
    } else {
      this.$store.state.loadingWords3500 = true;
      try {
        const words3500Data = this.commonApi.getInitialWords3500();
        this.$store.state.gaokaoWords = words3500Data.data;
        this.commonApi.writeWordCache('words3500', words3500Data);
      } catch(error) {
        console.error('3500离线词库加载失败', error);
        Toast.fail('词库加载失败');
      } finally {
        this.$store.state.loadingWords3500 = false;
      }
    }

  

  },
}

</script>

<style scoped>
/* 核心搜索框视觉强化 */
.primary-search-wrapper {
  margin: 15px 12px 20px 12px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(25, 137, 250, 0.18);
  border: 2px solid #1989fa;
  background-color: #f7faff;
  overflow: hidden;
}

.begin-suggestion-panel {
  border-top: 1px solid #d9e9fb;
  background: #fff;
}

.begin-suggestion-header {
  display: flex;
  justify-content: space-between;
  padding: 8px 14px;
  color: #7d8b99;
  font-size: 12px;
  background: #f7faff;
}

.begin-suggestion-list {
  max-height: 312px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.begin-suggestion-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 58px;
  padding: 9px 14px;
  border: 0;
  border-top: 1px solid #f1f3f5;
  color: #323233;
  text-align: left;
  background: #fff;
  cursor: pointer;
}

.begin-suggestion-item.active,
.begin-suggestion-item:active {
  background: #edf7ff;
}

.begin-suggestion-word {
  flex: 0 0 34%;
  padding-right: 10px;
  overflow: hidden;
  font-size: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.begin-suggestion-word strong {
  color: #1989fa;
}

.begin-suggestion-meta {
  display: flex;
  align-items: center;
  min-width: 0;
  color: #7d7e80;
  font-size: 13px;
}

.begin-suggestion-attribute {
  flex: 0 0 auto;
  margin-right: 7px;
  padding: 2px 5px;
  border-radius: 4px;
  color: #1989fa;
  background: #ecf6ff;
}

.begin-suggestion-meaning {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.primary-search-field .van-field__control {
  font-size: 18px !important;
  font-weight: bold;
  color: #323233;
}

.primary-label {
  font-weight: 800;
  font-size: 16px;
  color: #1989fa;
  margin-right: 8px;
}

.primary-search-field .van-icon-search {
  font-size: 22px;
  color: #1989fa;
  font-weight: bold;
}

.fade-leave-to{
  opacity:0;
  transform: translate3d(0,30px,0);
  position: absolute;
  z-index: -10;
}
.fade-enter{
  transform: translate3d(0,0px,0);
  position: absolute;
}
.fade-leave-active{
  transition: 2.5s all ease;
}
.fade-enter-active{
  transition: opacity 1.5s;
}

.ti-input::-webkit-scrollbar{
display:none;
}
</style>
